class checkListEdit {
  constructor(data = {}) {
    this.idCheckList = data.idCheckList || 0;
    this.descripcion = data.descripcion || "";
    this.descripcionIngles = data.descripcionIngles || "";
    this.descripcionTexto = data.descripcionTexto || "";
    this.descripcionTextoIngles = data.descripcionTextoIngles || "";
    this.estatus = data.estatus || true;
    this.checkListInspeccionGeneralTipos =
      data.checkListInspeccionGeneralTipos || [];
    this.checklistPuntoInspeccions = data.checklistPuntoInspeccions || [];
  }
}
class checkListAdd {
  constructor(data = {}) {
    this.idCheckList = data.idCheckList || 0;
    this.descripcion = data.descripcion || "";
    this.descripcionIngles = data.descripcionIngles || "";
    this.descripcionTexto = data.descripcionTexto || "";
    this.descripcionTextoIngles = data.descripcionTextoIngles || "";
    this.estatus = data.estatus || true;
    this.checkListInspeccionGeneralTipos =
      data.checkListInspeccionGeneralTipos || [];
    this.checklistPuntoInspeccions = data.checklistPuntoInspeccions || [];
  }
}

class checklistPuntoInspeccions {
  constructor(data = {}) {
    this.idCheckListPuntoInspeccion = data.idCheckListPuntoInspeccion || data.idChecklistPuntoInspeccion || 0;
    this.idCheckList = data.idCheckList || 0;
    this.descripcionPuntoInspeccion = data.descripcionPuntoInspeccion || "";
    this.descripcionTipoDato = data.descripcionTipoDato || "";
    this.idPuntoInspeccion = data.idPuntoInspeccion || 0;
    this.idTipoValor = data.idTipoValor || 0;
    this.requiereImagen = data.requiereImagen || false;
    this.orden = data.orden || 0;
    this.estatus = data.estatus || true;
  }
}

export { checkListEdit, checkListAdd, checklistPuntoInspeccions };
